import moment from 'moment';

export default ({
	EN: {
		title: usingClick => usingClick ? 'Appointment Schedule' : 'Appointment Request',
		instructionsClick: 'Please pick your preferred appointment date and select an available time slot.',
		instructionsNoClick: 'Please pick your preferred appointment date and time, and our team will get back with you.',
		availableTimeSlot: (usingClick, date, timeSlots) => {
			const timeSlotDate = moment.utc(new Date(date)).format('MMM DD, YYYY');
			if (!usingClick) {
				return `Preferred time slots on ${timeSlotDate}`;
			}
			return timeSlots.length && timeSlots.length > 1 ?
				`Available time slots on ${timeSlotDate}` :
				`Available time slot on ${timeSlotDate}`;
		},
		acknowledgeRequirements: 'I have read and understand the below inspection scheduling requirements.',
		vehiclePreparationLabel: 'Vehicle Preparation:',
		vehiclePreparation: 'Please ensure the vehicle is clean and accessible and that all original equipment is available to be inspected. You or a responsible party 18 years or older must be available to provide vehicle access to the inspector. Inspections take approximately 25 minutes and includes taking digital photos, performing an interior review, performing an exterior review, and performing a function check. The vehicle will not be driven during the inspection.'
	},
	ES: {
		title: usingClick => usingClick ? 'Horario de citas' : 'Solicitud de cita',
		instructionsClick: 'Seleccione la fecha de su cita preferida y seleccione una franja de tiempo disponible.',
		instructionsNoClick: 'Por favor seleccione la fecha y la hora de su cita preferida, y nuestro equipo se comunicará con usted.',
		availableTimeSlot: (usingClick, date) => {
			const timeSlotDate = moment.utc(new Date(date)).format('MMM DD, YYYY');
			return usingClick ?
				`Tiempo disponible en ${timeSlotDate}` :
				`Franjas horarias preferidas el ${timeSlotDate}`;
		},
		acknowledgeRequirements: 'He leído y entiendo los siguientes requisitos de programación de la inspección.',
		vehiclePreparationLabel: 'Preparación del vehículo:',
		vehiclePreparation: 'Asegúrese de que el vehículo esté limpio y accesible, y que todo el equipo original esté disponible para ser inspeccionado. Usted o una persona responsable de 18 años o más debe estar disponible para brindarle acceso al vehículo al inspector. Las inspecciones toman aproximadamente 25 minutos e incluyen la toma de fotos digitales, la realización de una revisión interior, la realización de una revisión exterior y la realización de una verificación de funcionamiento. El vehículo no será conducido durante la inspección.'
	}
});
